import React from 'react';
export function AboutSpeaker() {
  return <section className="bg-brand-lightMint py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-16" data-id="element-18">
          {/* Image Column */}
          <div className="w-full md:w-2/5 flex justify-center relative" data-id="element-19">
            {/* Decorative background circle */}
            <div className="absolute inset-0 bg-brand-mint/10 rounded-full scale-110 -z-10 blur-2xl" data-id="element-20"></div>
            <div className="relative" data-id="element-21">
              <img src="https://cdn.magicpatterns.com/uploads/v2dPAeQ83LA9794c8h8uSU/1.png" alt="Amee met een hond" className="w-64 h-64 md:w-80 md:h-80 object-cover rounded-full border-4 border-brand-mint/30 shadow-xl" data-id="element-22" />
              <div className="absolute -bottom-4 -right-4 bg-white px-6 py-2 rounded-full shadow-lg border border-teal-50" data-id="element-23">
                <p className="text-brand-mint font-bold text-sm" data-id="element-24">Amee</p>
              </div>
            </div>
          </div>

          {/* Text Column */}
          <div className="w-full md:w-3/5 text-center md:text-left" data-id="element-25">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-6" data-id="element-26">
              Ik ben Amee van Stressless Dogs en ik geef dit webinar
            </h2>

            <div className="space-y-5 text-lg text-gray-700 leading-relaxed" data-id="element-27">
              <p data-id="element-28">
                Als hondengedragsdeskundige is het welzijn en het plezier van
                een hond, maar ook van jou als mens, voor mij het
                allerbelangrijkste.
              </p>
              <p data-id="element-29">
                Vanuit mijn bedrijf Stressless Dogs heb ik de afgelopen jaren al
                meer dan <strong data-id="element-30">100.000+ hondenbaasjes</strong> en hun honden
                mogen helpen bij het versterken van hun band en het oplossen van
                problemen.
              </p>

              <div className="bg-white p-6 rounded-2xl border-l-4 border-brand-mint shadow-sm mt-8" data-id="element-31">
                <h3 className="font-bold text-slate-800 mb-2 flex items-center gap-2" data-id="element-32">
                  <span className="text-brand-mint" data-id="element-33">✨</span> Mijn Belofte
                </h3>
                <p className="text-base" data-id="element-34">
                  Na dit webinar snap jij hoe je met methodes die vrij zijn van
                  dwang, pijn, angst en straf probleemgedrag kan voorkomen.{' '}
                  <strong data-id="element-35">
                    Communiceren op een manier die aansluit bij de natuur van je
                    hond
                  </strong>{' '}
                  staat hierbij centraal. Je hond merkt dit meteen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}